export default __webpack_public_path__ + "static/3_17-d6acb1d8c40e9663d710b97c9d7e13fa.png";